import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactPaginate from "react-paginate";

let Rewardcashback = () => {
  let [data, setData] = useState();

  let navigate = useNavigate();

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  let [all, setAll] = useState(0);
  let [val, setVal] = useState("");
  let [notused, setnotUsed] = useState();
  let [expired, setExpired] = useState(0);
  let [notscratchyet, setnotscratchyet] = useState(0);
  let [indexs, setIndex] = useState(0);

  useEffect(() => {
    Start();
    // Payment();
    RewardDeath();
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let RewardDeath = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: indexs };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/reward_detailcashback",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setData(dat.data.data);

            let expireds = 0;
            let alls = 0;
            let notuseds = 0;
            let useds = 0;
            let notscratchs = 0;

            setAll(dat.data.countdec);
          } else {
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  let RewardDeaths = async (bot) => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: bot };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/reward_detailcashback",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setData(dat.data.data);

            let expireds = 0;
            let alls = 0;
            let notuseds = 0;
            let useds = 0;
            let notscratchs = 0;

            setAll(dat.data.countdec);
          } else {
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  let RewardDeathsview = async (bot) => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, limit: 10, skip: 0, val: bot, search: true };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/reward_detailcashback",
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data.data,
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          if (dat.data.status === true) {
            setnotUsed(dat.data.data);
            setExpired(dat.data.countdec);
          } else {
          }
        })
        .catch((ee) => {});
    } catch (err) {}
  };

  function calculateDates(daysToAdd) {
    const currentDate = new Date(daysToAdd);
    currentDate.setDate(currentDate.getDate());

    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = currentDate.getFullYear();

    const hours = String(currentDate.getHours()).padStart(2, "0");
    const minutes = String(currentDate.getMinutes()).padStart(2, "0");
    const seconds = String(currentDate.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  const tabRef = useRef(null);

  useEffect(() => {
    const tabElement = tabRef.current;

    const handleTabChange = (event) => {
      console.log(event.target.id);
    };

    // Add event listener for tab shown.bs.tab
    tabElement.addEventListener("shown.bs.tab", handleTabChange);

    return () => {
      // Cleanup the event listener when the component unmounts
      tabElement.removeEventListener("shown.bs.tab", handleTabChange);
    };
  }, []);

  const handlePageClick = async (event) => {
    console.log(event.selected);
    setIndex(event.selected);
    RewardDeaths(event.selected);
    try {
    } catch (err) {}
  };

  let Submit = () => {
    if (val === undefined || val === "" || val === null) {
      alert("Enter Value");
      return;
    }

    RewardDeathsview(val);
  };

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10">
          <div className="d-flex justify-content-between">
            <h1 style={{ textAlign: "center", fontSize: 23 }} className="mt-4">
              Cashback details
            </h1>
            <div style={{ padding: 10 }}>
              <button
                onClick={() => {
                  navigate("/notiedit");
                }}
              >
                Edit Notification
              </button>
            </div>
          </div>
          <div class="container mt-5 w-100 fixed">
            <ul
              class="nav nav-tabs w-100 d-flex"
              id="myTab"
              role="tablist"
              style={{ justifyContent: "space-between" }}
              ref={tabRef}
            >
              <li class="nav-item" role="presentation" style={{}}>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel="next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  pageCount={all / 10}
                  previousLabel="< previous"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination justify-content-center"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  forcePage={indexs}
                />
              </li>
            </ul>

            <p>Filter</p>

            <div className="row">
              <div className="d-flex">
                <input
                  onChange={(e) => {
                    setVal(e.target.value);
                  }}
                  type="text"
                />
                <button
                  style={{ marginLeft: 20 }}
                  onClick={() => {
                    Submit();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          <div
            className="tab-content mt-5 row"
            id="myTabContent"
            style={{
              overflowY: "scroll",
              height: "70vh",
              scrollbarWidth: "none",
            }}
          >
            <div
              className="tab-pane fade show active col-6"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <table class="table table-striped table-hover table-bordered table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Phone No</th>
                    <th scope="col">Time</th>
                    <th scope="col">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((dd, key) => {
                    return (
                      <>
                        <tr>
                          <th scope="row">{key + indexs * 10 + 1}</th>
                          <td
                            onClick={() => {
                              navigate("/useralldetail", { state: dd.users });
                            }}
                          >
                            {dd?.users?.name}
                          </td>
                          <td  onClick={() => {
                             RewardDeathsview(dd?.users?.phoneno);
                            }} >
                            {dd?.users?.phoneno}
                            <br />
                            {calculateDates(dd?.createdAt)}
                          </td>
                          <td>
                            card last 4 digit :{" "}
                            <span style={{ color: "blue", fontWeight: "700" }}>
                              {dd?.cardid}{" "}
                            </span>{" "}
                            <br />
                            {dd?.payss?.xopayid}
                          </td>
                          <td>{dd?.amount}</td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="col-6">
              <p>Count : {expired} </p>
              <table class="table table-striped table-hover table-bordered table-sm">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">User Name</th>
                    <th scope="col">Phone No</th>
                    <th scope="col">Time</th>
                    <th scope="col">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {notused?.map((dd, key) => {
                    return (
                      <>
                        <tr>
                          <th scope="row">{key + indexs * 10 + 1}</th>
                          <td
                            onClick={() => {
                              navigate("/useralldetail", { state: dd.users });
                            }}
                          >
                            {dd?.users?.name}
                          </td>
                          <td>
                            {dd?.users?.phoneno}
                            <br />
                            {calculateDates(dd?.createdAt)}
                          </td>
                          <td>
                            card last 4 digit :{" "}
                            <span style={{ color: "blue", fontWeight: "700" }}>
                              {dd?.cardid}{" "}
                            </span>{" "}
                            <br />
                            {dd?.payss?.xopayid}
                          </td>
                          <td>{dd?.amount}</td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rewardcashback;
